import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { DRAWER_NAVIGATION } from "./constants";
import styles from "./HeaderV3.module.scss";
import { ReactComponent as BeatBreadLogo } from "../../assets/SVGs/logos/beatBreadLogoResponsive.svg";
import { ARTIST_ENROLLMENT, DEAL_COMPARISON, FUNDING_NETWORK, HOME } from "../../routes/constants";
import { Box, Drawer } from "@mui/material";
import { ReactComponent as Hamburger } from "../../assets/SVGs/hamburger-menu.svg";
import { ReactComponent as Xclose } from "../../assets/SVGs/x-close.svg";
import NavDrawer from "./helper";
import Button2 from "../Button2";

function HeaderV3 (){
  const location = useLocation();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  useEffect(() => {
    setIsDrawerOpen(false); // Close drawer on route change
  }, [location]);

  const handleDrawerToggle = () => {
      setIsDrawerOpen(!isDrawerOpen);
  };

  const renderSecondaryNavbar = () => {
    return (
      <>
        {DRAWER_NAVIGATION.map((item, i) => (
          <NavDrawer items={item.options} title={item.title} key={i}/>
        ))}
      </>
    );
  };

  const list = () => (
    <Box role="presentation" >
        {renderSecondaryNavbar()}
        <div className={styles.mobileLoginContainer}>
          <Button2 light sm to={FUNDING_NETWORK} className={styles.loginBtn} ><p>Get&nbsp;Offers</p></Button2>
          <Button2 white sm outline className={styles.loginBtn} to={DEAL_COMPARISON}><p>Compare Offers</p></Button2>
          <Button2 light sm tertiary className={styles.loginBtn} to={`${ARTIST_ENROLLMENT}?isLogin=true`}><p>Log&nbsp;In</p></Button2>
        </div>
    </Box>
);

  return (
    <div id="bBNavHeader" className={styles.mainNavContainer}>
        <div className={styles.navContainer}>
          <div className={styles.primaryNavbarContainer}>
            <div className={styles.navbarLeft}>
              <div className={styles.navbarLogo}>
                <Link to={HOME} className={styles.navLogo}>
                  <BeatBreadLogo />
                </Link>
              </div>
              <div className={styles.dropdowns}>
                {renderSecondaryNavbar()}
              </div>
            </div>
            <div className={styles.navbarRight}>
            <Button2 light xs tertiary to={`${ARTIST_ENROLLMENT}?isLogin=true`} className={styles.loginBtn}><p>Log&nbsp;In</p></Button2>
              <div className={styles.navLinksContainer}>
                <Button2 white xs outline to={DEAL_COMPARISON} className={styles.loginBtn}><p>Compare&nbsp;Offers</p></Button2>
                <Button2 light xs to={FUNDING_NETWORK} className={styles.loginBtn} ><p>Get&nbsp;Offers</p></Button2>
              </div>
            </div>
          </div>
          <div className={styles.navMobileMenuHeader}>
            <Link to={HOME} className={styles.navMobileLogo} onClick={() => setIsDrawerOpen(false)}>
              <BeatBreadLogo />
            </Link>
            <div
              className={styles.navMobileMenuButton}
              onClick={() => setIsDrawerOpen(!isDrawerOpen)}
            >
              {isDrawerOpen ? <Xclose /> : <Hamburger />}
            </div>
          </div>
          <Drawer
            variant="persistent"
            anchor={"top"}
            open={isDrawerOpen}
            onClose={handleDrawerToggle}
            className={`${styles.mobileDrawer}`}
          >
            {list()}
          </Drawer>
        </div>
      </div>
  );

}

export default HeaderV3;